module.exports = "/images/icon_32_star.png?87eb9c3a7b63f6d34ed2ca3eff2ef4df";